import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          nav: {
            home: 'Home',
            events: 'Events',
            rsvp: 'RSVP',
            my_rsvp: 'RSVP',
            itinerary: 'schedule',
            travel: 'travel',
            faq: 'FAQ',
            contact: 'Any Questions?',
            admin: 'Admin',
            logout: 'Logout',
            language: 'Language'
          },
          travel: {
            subtitle: 'Customised travel plan details to help you book your trip',
            getting_to_albacete_title: 'Getting to Albacete',
            from_alicante_title: 'From Alicante Airport',
            from_alicante_desc: 'Alicante is the closest major airport to Albacete. Once you arrive in Alicante, the quickest option is the high-speed train from Alicante Terminal railway station to Albacete‑Los Llanos railway station, which takes around 55 minutes. To get from the airport to the train station, take the C6 airport bus (25min, leaving every 20min, €4.50), or even easier, take a taxi (15min, €20). Rental cars are also available if you prefer; it\'s a 1hr 45min drive to Albacete.',
            omio_link_text: 'Please check <0>http://www.omio.com</0> to check train schedules and buy tickets.',
            from_valencia_title: 'From Valencia Airport',
            from_valencia_desc1: 'Valencia is another convenient airport for reaching Albacete. Once you arrive in Valencia, the quickest option is the direct train from Valencia-Joaquín Sorolla railway station to Albacete-Los Llanos railway station, which takes around 1 hour 50 minutes to 2 hours depending on the service.',
            from_valencia_desc2: 'To get from Valencia Airport to the train station, take Metrovalencia lines 3 or 5 from the airport to Xàtiva station (about 25 minutes, trains every 10–15 minutes, around €5), then walk about 10 minutes to Valencia-Joaquín Sorolla station. Alternatively, you can take a taxi directly from the airport to the station (15–20 minutes, about €20–€25).',
            from_valencia_desc3: 'Rental cars are also available at the airport if you prefer to drive; the journey to Albacete takes about 1 hour 50 minutes via the A-3 and A-31 motorways.',
            from_madrid_title: 'From Madrid Airport',
            from_madrid_desc1: 'Madrid is another convenient airport for reaching Albacete. Once you arrive at Madrid–Barajas Airport, the quickest option is the direct train from Madrid-Chamartín-Clara Campoamor railway station to Albacete-Los Llanos railway station, which takes around 1 hour 30 minutes on high-speed AVE services.',
            from_madrid_desc2: 'To get from the airport to the train station, take the Cercanías C1 or C10 train from Terminal T4 directly to Chamartín station (about 15–20 minutes, trains every 15–20 minutes, around €2.60). Alternatively, a taxi from the airport to Chamartín takes about 15–20 minutes and typically costs around €25–€30.',
            from_madrid_desc3: 'Rental cars are also available at the airport if you prefer to drive; the journey to Albacete takes about 2 hours 45 minutes via the A-3 and A-31 motorways.',
            flights_title: 'Flights',
            cork_alicante_title: 'Flying from Cork to Alicante',
            cork_alicante_desc: 'Isn\'t it great to be from Cork? Ryanair operates highly affordable direct flights between Cork and Alicante, that take around 2 hours 40 minutes.',
            return_approx: 'Return / Approx per person',
            outbound_flights: 'Outbound Flights',
            inbound_flights: 'Inbound Flights',
            shannon_alicante_title: 'Flying from Shannon to Alicante',
            shannon_alicante_desc: 'While the Cork to Alicante flights are very convenient, the times might not suit everyone. Ryanair offer Thursday evening and Friday morning flights from Shannon, returning Monday, for example.',
            cork_valencia_title: 'Flying from Cork to Valencia',
            cork_valencia_desc: 'Cork to Valencia is another nice option, with flights early Friday morning, returning Monday afternoon',
            kerry_alicante_title: 'Flying from Kerry to Alicante',
            kerry_alicante_desc: 'Yet more flight options are available from Kerry airport. Getting the train from Cork to Farranfore (1hr 40min) allows you to get a a 4pm Friday flight to Alicante, meaning you get to work Friday morning (booo). However, be aware that you\'ll missed the pre-wedding drinks on the Friday evening.',
            dublin_alicante_title: 'Flying from Dublin to Alicante',
            dublin_alicante_desc: 'For our Dublin guests, there are a tonne of options from Dublin to Alicante. It\'s not Cork though.',
            dublin_valencia_title: 'Flying from Dublin to Valencia',
            dublin_valencia_desc: 'Another great coastal alternative to Alicante. Ryanair flies direct from Dublin to Valencia. Valencia is roughly a 2-hour drive or high-speed train ride to Albacete.',
            dublin_madrid_title: 'Flying from Dublin to Madrid',
            dublin_madrid_desc: 'Madrid is another great option from Dublin, with daily airlingus flights available. The journey from Madrid to Albacete is slightly longer than for Alicante however.',
            uk_flights_title: 'Flights from the UK',
            heathrow_madrid_title: 'Flying from Heathrow to Madrid',
            heathrow_madrid_desc: 'Madrid is a great option from London given the high volume of flights. The journey from Madrid airport to Albacete takes just over two hours.',
            heathrow_valencia_title: 'Flying from Heathrow to Valencia',
            gatwick_alicante_title: 'Flying from Gatwick to Alicante',
            gatwick_valencia_title: 'Flying from Gatwick to Valencia',
            stansted_alicante_title: 'Flying from Stansted to Alicante',
            stansted_valencia_title: 'Flying from Stansted to Valencia',
            luton_alicante_title: 'Flying from Luton to Alicante',
            no_flights_found: 'No flights found'
          },
          accommodation: {
            title_svg: '/images/text/where_to_stay.svg',
            description: 'Albacete is not a touristy town, the accommodation offer is limited so we recommend booking early. Please text us if you have any questions before booking any of these options or any other that you find.',
            google_maps: 'VIEW HOTEL LOCATIONS ON GOOGLE MAPS',
            hotels: {
              los_llanos: {
                name: "HOTEL LOS LLANOS",
                description: "Right in the middle of town, very good restaurant underneath. Get 10% discount when booking by phone or email and using the confirmation number 10627."
              },
              eurostars: {
                name: "EUROSTARS GRAN HOTEL",
                description: "One of the most beautiful buildings in town. Right in the city centre. Features an elegant early 20th-century façade and spacious, highly-rated rooms. Easy walking access to nearby restaurants, bars, and the Cathedral."
              },
              parador: {
                name: "PARADOR DE ALBACETE",
                description: "Spanish old style hotel outside of town. It has a pool, great if you want to chill having a drink by the pool, 15min taxi from city centre."
              },
              europa: {
                name: "HOTEL EUROPA",
                description: "In city centre. A smart, family-friendly hotel known for its excellent value and secure on-site parking. Guests appreciate the quiet rooms and great buffet breakfast."
              },
              florida: {
                name: "HOTEL FLORIDA",
                description: "In city centre. Located next to the Bullring with an on-site restaurant serving popular homemade Mediterranean dishes. Offers comfortable rooms and friendly service."
              },
              san_antonio: {
                name: "HOTEL SAN ANTONIO",
                description: "In city centre. Modern hotel situated right next to the Cathedral, featuring comfy beds and spacious bathrooms. Highly praised for its prime location and helpful staff."
              },
              universidad: {
                name: "HOTEL UNIVERSIDAD",
                description: "Walking distance to city centre. Set in a quiet residential area near the university, offering easy parking and pet-friendly rooms. Known for its functional design and good breakfast."
              },
              urbanlux: {
                name: "APARTAMENTOS URBANLUX",
                description: "Several locations around town. They fit 4 to 6 people. Modern, fully-equipped apartments with contactless check-in, praised for their cleanliness. Great for groups and families, with pet-friendly options available. Email info@urbanlux-apartamentos.com for more info."
              }
            }
          },
          hero: {
            date: '29th of August, 2026',
            line1: "We're getting",
            line2: 'married !',
            subtext: "We’d love you to join us in\nAlbacete, Spain, to celebrate our\nbiggest themed party yet."
          },
          timer: {
            days: 'Days',
            hours: 'Hours',
            minutes: 'Minutes',
            seconds: 'Seconds'
          },
          common: {
            loading: 'Loading...',
            language: 'Language',
            welcome: 'Welcome, {{name}}!',
            submit: 'Submit',
            saving: 'Saving...',
            back: 'Back'
          },
          rsvp: {
            gate_heading: 'Enter your invite code',
            title: "RSVP",
            link_text: 'Click here to RSVP',
            deadline: 'Kindly reply by the 1st of July',
            code_label: 'Invite Code',
            code_placeholder: 'Enter your 5-character code',
            enter_code: 'Submit',
            code_error_invalid: 'Invalid code. Please try again.',
            code_error_used: 'This code has already been used.',
            form: {
              name_label: 'Name',
              yes: 'Yes',
              no: 'No',
              email_label: 'Email',
              email_placeholder: 'Optional',
              events: {
                ie_legend: 'Will you be celebrating with us in Ireland? (July 18th, 2026)',
                es_legend: 'Will you be celebrating with us in Spain? (August 29th, 2026)',
                pb_legend: 'Will you be at the Pre-Boda drinks in Spain? (August 28th, 2026)',
              },
              attending_yes: 'Absolutely',
              attending_no: 'Sadly no',
              plus_one_legend: 'Do you have a Plus One?',
              plus_one_yes: 'Yes',
              plus_one_no: 'No',
              plus_one_name_label: 'Guest Name',
              plus_one_name_placeholder: 'Full Name of your guest',
              plus_one_dietary_label: 'Plus One Dietary requirements (optional)',
              child_name_label: 'Child {{index}} Name',
              child_name_placeholder: 'Full Name of child',
              child_dietary_label: 'Child {{index}} Dietary requirements (optional)',
              dietary_label: 'Dietary requirements (optional)',
              dietary_placeholder: 'Any allergies or dietary restrictions?',
              message_label: 'Message',
              message_placeholder: 'Any questions or a note for the couple?',
              submit_btn: 'Submit RSVP',
              submitting: 'Submitting RSVP...',
              children_label: 'How many children in your party bringing?',
              dietary_optional: 'Dietary requirement (optional)',
              success_title: 'Thank you!',
              success_msg: 'RSVP submitted — thank you!',
              error_msg: 'We were unable to send your RSVP. Please try again.',
              success_thanks: 'Thank You!',
              success_recorded: 'Your RSVP has been recorded.',
              success_waiting: 'We can\'t wait to celebrate with you!',
              your_table: 'Your Table',
              error_generic: 'Something went wrong. Please try again.',
              accommodation_label: 'Where are you staying in Albacete?',
              accommodation_placeholder: 'Select a hotel or type your own...',
              checkin_label: 'Check-in',
              checkout_label: 'Check-out'
            }
          },
          schedule: {
            bus_pickup: 'Bus Pick Up - Punta del Parque Abelardo Sánchez',
            ceremony: 'Ceremony',
            cocktail: 'Cocktail',
            dinner: 'Dinner',
            band: 'Band',
            dj: 'D.J.',
            first_bus: '1st Bus Departs - Punta del Parque Abelardo Sánchez',
            second_bus: '2nd Bus',
            siesta: 'Siesta',
            ie_ceremony: 'Irish Wedding Celebration',
            ie_reception: 'Reception & Dancing',
            ie_address: 'Poc ar Buile\nBallinrostig\nWhitegate\nCo. Cork\nP25 YY53',
            ie_maps_link: 'https://www.google.com/maps/place/Poc+ar+Buile/@51.8179986,-8.189375,17z/',
            ie_bus: 'Buses to and from town will be organised',
            welcome_drinks: 'Welcome Food & Drinks in town',
            pb_location: 'La Nena - Craft Beer',
            pb_address: 'C. Blasco Ibáñez, 9, 02004 Albacete, Spain',
            pb_website: 'https://cervezalanena.com/',
            pb_maps_link: 'https://www.google.com/maps/place/Factory+Bar+La+Nena+-+Craft+Beer/@38.9941315,-1.8636537,17z/data=!4m6!3m5!1s0xd665fb802f85373:0xee8ea6f8fd28dcbf!8m2!3d38.9941274!4d-1.8610788!16s%2Fg%2F11dxpdhp0j?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D',
            es_location: 'Finca El Batanejo',
            es_address: 'Villalgordo Del Jucar, Albacete',
            es_website: 'https://www.instagram.com/fincaelbatanejo/',
            es_maps_link: 'https://www.google.com/maps/place/Finca+El+Batanejo/@39.3348569,-2.0911541,17z/',
            party_photos: 'Wedding Party Photos',
            rehearsal: 'Wedding Party Rehearsal & Dinner',
            street_map_title: 'Albacete Town Map',
            zoom_map: 'Click to zoom',
            close: 'Close',
            open_google_maps: 'Open in Google Maps',
            bus_meeting_point_title: 'Bus Meeting Point',
            bus_meeting_point_desc: 'Punta del Parque Abelardo Sánchez — This is where the bus will pick you up and drop you off.',
            open_in_maps: 'Open in Google Maps'
          },
          faq_section: {
            q1: "WHAT WILL THE WEATHER BE LIKE THIS TIME OF YEAR?",
            a1_subtitle1: "Avg. Temperatures",
            a1_text1_1: "33°C (92°F) high",
            a1_text1_2: "17°C (63°F) low",
            a1_subtitle2: "Conditions",
            a1_text2_1: "Clear skies",
            a1_text2_2: "Very sunny",
            a1_subtitle3: "Precipitation",
            a1_text3_1: "Dry climate",
            a1_text3_2: "Practically 0% rain",
            a1_forecast: "Current 10-day weather forecast for albacete",
            a1_weather_btn: "ALBACETE WEATHER",
            q2: "WHERE ARE THE CEREMONY AND THE RECEPTION TAKING PLACE?",
            a2: "Both the ceremony (19:00) and the reception, including a cocktail hour (20:00) and dinner (21:30), will take place at the same countryside venue on Saturday.",
            q3: "WHAT SHOULD I WEAR? IS THERE A DRESS CODE?",
            a3_p1: "Late August in Albacete is typically hot and sunny during the day, with a pleasant drop in temperature after sunset.",
            a3_ladies: "Ladies",
            a3_ladies_text: ": Since the venue is in the countryside, block heels, wedges, or dressy flats are better than stilettos.",
            a3_gentlemen: "Gentlemen",
            a3_gentlemen_text: ": Lightweight suits or dress shirts are perfect. Ties are optional, comfort in the heat is key!",
            a3_evening: "Evening layer",
            a3_evening_text: ": The event will be outdoors. Nights can cool to around 17°C, so consider bringing a shawl, wrap, or light jacket.",
            a3_p5: "There will be a place to leave jackets and extra shoes at the venue if you'd like to change later. Most importantly, we want everyone to feel comfortable and look amazing!"
          }
        }
      },
      es: {
        translation: {
          nav: {
            home: 'Inicio',
            events: 'Eventos',
            rsvp: 'RSVP',
            my_rsvp: 'RSVP',
            itinerary: 'horario',
            travel: 'viaje',
            faq: 'preguntas',
            contact: '¿Alguna pregunta?',
            admin: 'Admin',
            logout: 'Cerrar Sesión',
            language: 'Idioma'
          },
          travel: {
            subtitle: 'Detalles de vuelos para planificar tu viaje a Albacete',
            getting_to_albacete_title: 'Cómo llegar a Albacete',
            from_alicante_title: 'Desde el Aeropuerto de Alicante',
            from_alicante_desc: 'Alicante es el aeropuerto principal más cercano a Albacete. Una vez que llegues a Alicante, la opción más rápida es el tren de alta velocidad desde la estación de tren de Alicante Terminal hasta la estación de Albacete-Los Llanos, que tarda unos 55 minutos. Para ir del aeropuerto a la estación de tren, puedes coger el autobús C6 (25 min, cada 20 min, 4,50 €) o, más fácil aún, un taxi (15 min, 20 €). También hay coches de alquiler disponibles si lo prefieres; el trayecto en coche a Albacete dura 1 h 45 min.',
            omio_link_text: 'Por favor, consulta <0>http://www.omio.com</0> para ver los horarios de los trenes y comprar los billetes.',
            from_valencia_title: 'Desde el Aeropuerto de Valencia',
            from_valencia_desc1: 'Valencia es otro aeropuerto conveniente para llegar a Albacete. Una vez que llegues a Valencia, la opción más rápida es el tren directo desde la estación de tren de Valencia-Joaquín Sorolla hasta la de Albacete-Los Llanos, que tarda entre 1 hora 50 minutos y 2 horas, dependiendo del servicio.',
            from_valencia_desc2: 'Para ir del aeropuerto de Valencia a la estación de tren, toma las líneas 3 o 5 de Metrovalencia desde el aeropuerto hasta la estación de Xàtiva (unos 25 minutos, trenes cada 10-15 minutos, alrededor de 5 €) y luego camina unos 10 minutos hasta la estación de Valencia-Joaquín Sorolla. Alternativamente, puedes tomar un taxi directamente desde el aeropuerto a la estación (15-20 minutos, unos 20 € - 25 €).',
            from_valencia_desc3: 'También hay coches de alquiler disponibles en el aeropuerto si prefieres conducir; el viaje a Albacete dura aproximadamente 1 hora y 50 minutos por las autovías A-3 y A-31.',
            from_madrid_title: 'Desde el Aeropuerto de Madrid',
            from_madrid_desc1: 'Madrid es otro aeropuerto conveniente para llegar a Albacete. Una vez que llegues al aeropuerto de Madrid-Barajas, la opción más rápida es el tren directo desde la estación de tren de Madrid-Chamartín-Clara Campoamor hasta la de Albacete-Los Llanos, que tarda aproximadamente 1 hora y 30 minutos en los servicios de alta velocidad AVE.',
            from_madrid_desc2: 'Para ir del aeropuerto a la estación de tren, toma el tren de Cercanías C1 o C10 desde la Terminal T4 directamente a la estación de Chamartín (unos 15-20 minutos, trenes cada 15-20 minutos, unos 2,60 €). Alternativamente, un taxi desde el aeropuerto hasta Chamartín tarda unos 15-20 minutos y suele costar entre 25 € y 30 €.',
            from_madrid_desc3: 'También hay coches de alquiler disponibles en el aeropuerto si prefieres conducir; el viaje a Albacete dura unas 2 horas y 45 minutos por las autovías A-3 y A-31.',
            flights_title: 'Vuelos',
            cork_alicante_title: 'Volar de Cork a Alicante',
            cork_alicante_desc: '¿A que es genial ser de Cork? Ryanair opera vuelos directos muy económicos entre Cork y Alicante, que tardan unas 2 horas y 40 minutos.',
            return_approx: 'Ida y vuelta / Aprox. por persona',
            outbound_flights: 'Vuelos de ida',
            inbound_flights: 'Vuelos de vuelta',
            shannon_alicante_title: 'Volar de Shannon a Alicante',
            shannon_alicante_desc: 'Aunque los vuelos de Cork a Alicante son muy cómodos, los horarios pueden no venirles bien a todos. Ryanair ofrece vuelos los jueves por la tarde y los viernes por la mañana desde Shannon, regresando el lunes, por ejemplo.',
            cork_valencia_title: 'Volar de Cork a Valencia',
            cork_valencia_desc: 'Volar de Cork a Valencia es otra buena opción, con vuelos el viernes temprano por la mañana y regreso el lunes por la tarde.',
            kerry_alicante_title: 'Volar de Kerry a Alicante',
            kerry_alicante_desc: 'Hay aún más opciones de vuelo desde el aeropuerto de Kerry. Coger el tren de Cork a Farranfore (1 h 40 min) te permite coger un vuelo el viernes a las 16:00 a Alicante, lo que significa que puedes trabajar el viernes por la mañana (¡buuu!). Sin embargo, ten en cuenta que te perderás las copas de la pre-boda el viernes por la noche.',
            dublin_alicante_title: 'Volar de Dublín a Alicante',
            dublin_alicante_desc: 'Para nuestros invitados de Dublín, hay muchísimas opciones de Dublín a Alicante. Pero no es Cork.',
            dublin_valencia_title: 'Volar de Dublín a Valencia',
            dublin_valencia_desc: 'Otra gran alternativa costera a Alicante. Ryanair vuela directo de Dublín a Valencia. Valencia está a unas 2 horas en coche o en tren de alta velocidad de Albacete.',
            dublin_madrid_title: 'Volar de Dublín a Madrid',
            dublin_madrid_desc: 'Madrid es otra gran opción desde Dublín, con vuelos diarios de Aer Lingus disponibles. Sin embargo, el viaje de Madrid a Albacete es un poco más largo que desde Alicante.',
            uk_flights_title: 'Vuelos desde el Reino Unido',
            heathrow_madrid_title: 'Volar de Heathrow a Madrid',
            heathrow_madrid_desc: 'Madrid es una gran opción desde Londres dada la alta frecuencia de vuelos. El viaje desde el aeropuerto de Madrid a Albacete dura poco más de dos horas.',
            heathrow_valencia_title: 'Volar de Heathrow a Valencia',
            gatwick_alicante_title: 'Volar de Gatwick a Alicante',
            gatwick_valencia_title: 'Volar de Gatwick a Valencia',
            stansted_alicante_title: 'Volar de Stansted a Alicante',
            stansted_valencia_title: 'Volar de Stansted a Valencia',
            luton_alicante_title: 'Volar de Luton a Alicante',
            no_flights_found: 'No se encontraron vuelos'
          },
          accommodation: {
            title_svg: '/images/text/alojamiento_en_albacete.svg',
            description: 'Albacete no tiene una gran oferta hotelera como otros destinos más turísticos, por lo que los alojamientos disponibles pueden llenarse con rapidez, especialmente en los días previos a la Feria de Albacete, que comienza una semana después de la boda. Por eso os recomendamos organizar el alojamiento con tiempo.\n\nSi necesitáis alguna recomendación o queréis consultarnos sobre algún hotel o apartamento antes de reservar, estaremos encantados de ayudar.',
            google_maps: 'VER UBICACIÓN DE LOS HOTELES EN GOOGLE MAPS',
            hotels: {
              los_llanos: {
                name: "HOTEL LOS LLANOS",
                description: "En pleno centro, muy buen restaurante debajo. Obtén un 10% de descuento al reservar por teléfono o email usando el número de confirmación 10627."
              },
              eurostars: {
                name: "EUROSTARS GRAN HOTEL",
                description: "Uno de los edificios más bonitos de la ciudad. Justo en el centro. Cuenta con una elegante fachada de principios del siglo XX y habitaciones amplias y bien valoradas. Fácil acceso a pie a restaurantes, bares y la Catedral."
              },
              parador: {
                name: "PARADOR DE ALBACETE",
                description: "Hotel de estilo clásico español a las afueras. Tiene piscina, ideal si quieres relajarte tomando algo junto a ella, a 15 min en taxi del centro."
              },
              europa: {
                name: "HOTEL EUROPA",
                description: "En el centro. Un hotel elegante y familiar conocido por su excelente relación calidad-precio y aparcamiento seguro. Los huéspedes valoran la tranquilidad de las habitaciones y el desayuno buffet."
              },
              florida: {
                name: "HOTEL FLORIDA",
                description: "En el centro. Situado junto a la Plaza de Toros, con un restaurante que sirve platos caseros mediterráneos. Ofrece habitaciones cómodas y un servicio amable."
              },
              san_antonio: {
                name: "HOTEL SAN ANTONIO",
                description: "En el centro. Hotel moderno situado junto a la Catedral, con camas cómodas y baños amplios. Muy valorado por su ubicación y la amabilidad del personal."
              },
              universidad: {
                name: "HOTEL UNIVERSIDAD",
                description: "A poca distancia del centro. Ubicado en una zona residencial tranquila cerca de la universidad, ofrece facilidad para aparcar y admite mascotas. Conocido por su diseño funcional y buen desayuno."
              },
              urbanlux: {
                name: "APARTAMENTOS URBANLUX",
                description: "Varias ubicaciones en la ciudad. Apartamentos para 4 a 6 personas. Modernos, equipados y con check-in sin contacto, destacados por su limpieza. Ideales para grupos y familias, con opciones que admiten mascotas. Email info@urbanlux-apartamentos.com para más info."
              }
            }
          },
          hero: {
            date: '29 de agosto, 2026',
            line1: '¡Nos',
            line2: 'casamos!',
            subtext: "Nos haría mucha ilusión que nos acompañaseis este verano para celebrar nuestra fiesta temática más grande hasta la fecha."
          },
          timer: {
            days: 'Días',
            hours: 'Horas',
            minutes: 'Minutos',
            seconds: 'Segundos'
          },
          common: {
            loading: 'Cargando...',
            language: 'Idioma',
            welcome: '¡Bienvenido/a, {{name}}!',
            submit: 'Enviar',
            saving: 'Guardando...',
            back: 'Atrás'
          },
          rsvp: {
            gate_heading: 'Introduce tu clave de acceso',
            title: 'RSVP',
            link_text: 'Haz clic aquí para confirmar tu asistencia',
            deadline: 'Por favor responde antes del 1 de Julio',
            code_label: 'Código de Invitación',
            code_placeholder: 'Ingresa tu código de 5 caracteres',
            enter_code: 'Enviar',
            code_error_invalid: 'Código inválido. Intenta de nuevo.',
            code_error_used: 'Este código ya ha sido usado.',
            form: {
              name_label: 'Nombre',
              yes: 'Sí',
              no: 'No',
              email_label: 'Correo Electrónico',
              email_placeholder: 'Opcional',
              events: {
                ie_legend: '¿Celebrarás con nosotros en Irlanda? (18 de julio, 2026)',
                es_legend: '¿Celebrarás con nosotros en España? (29 de agosto, 2026)',
                pb_legend: '¿Asistirás a la Pre-Boda en España? (28 de agosto, 2026)',
              },
              attending_yes: '¡Absolutamente!',
              attending_no: 'Tristemente no',
              plus_one_legend: '¿Tienes un Acompañante?',
              plus_one_yes: 'Sí',
              plus_one_no: 'No',
              plus_one_name_label: 'Nombre del Acompañante',
              plus_one_name_placeholder: 'Nombre completo de tu invitado',
              plus_one_dietary_label: 'Necesidades alimentarias del acompañante (opcional)',
              child_name_label: 'Nombre del niño {{index}}',
              child_name_placeholder: 'Nombre completo del niño',
              child_dietary_label: 'Necesidades alimentarias del niño {{index}} (opcional)',
              dietary_label: '¿Tienes alguna restricción alimentaria?',
              dietary_placeholder: 'Alergias, intolerancias...',
              message_label: 'Un mensaje para la pareja',
              message_placeholder: 'Cualquier duda o un mensaje para la pareja',
              submit_btn: 'Enviar RSVP',
              submitting: 'Enviando RSVP...',
              children_label: '¿Cuántos niños vienen en vuestro grupo?',
              dietary_optional: 'Necesidades alimentarias (opcional)',
              success_title: '¡Gracias!',
              success_msg: 'RSVP enviado — ¡gracias!',
              error_msg: 'No pudimos enviar tu RSVP. Por favor intenta de nuevo.',
              success_thanks: '¡Gracias!',
              success_recorded: 'Tu confirmación ha sido registrada.',
              success_waiting: '¡Estamos deseando celebrar contigo!',
              your_table: 'Tu Mesa',
              error_generic: 'Algo salió mal. Por favor intenta de nuevo.',
              accommodation_label: '¿Dónde os alojaréis en Albacete?',
              accommodation_placeholder: 'Selecciona un hotel o escribe el tuyo...',
              checkin_label: 'Check-in',
              checkout_label: 'Check-out'
            }
          },
          schedule: {
            bus_pickup: 'Recogida en autobús – Punta del Parque Abelardo Sánchez',
            ceremony: 'Ceremonia',
            cocktail: 'Cóctel',
            dinner: 'Cena',
            band: 'Banda',
            dj: 'DJ',
            first_bus: 'Salida del 1.er autobús – Punta del Parque Abelardo Sánchez',
            second_bus: '2.º autobús',
            siesta: 'Siesta',
            ie_ceremony: 'Celebración de Boda en Irlanda',
            ie_reception: 'Recepción y Baile',
            ie_address: 'Poc ar Buile\nBallinrostig\nWhitegate\nCo. Cork\nP25 YY53',
            ie_maps_link: 'https://www.google.com/maps/place/Poc+ar+Buile/@51.8179986,-8.189375,17z/',
            ie_bus: 'Se organizarán autobuses de ida y vuelta desde la ciudad',
            welcome_drinks: 'Preboda',
            pb_location: 'Cerveza La Nena',
            pb_address: 'C. Blasco Ibáñez, 9, 02004 Albacete, Spain',
            pb_website: 'https://cervezalanena.com/',
            pb_maps_link: 'https://www.google.com/maps/place/Factory+Bar+La+Nena+-+Craft+Beer/@38.9941315,-1.8636537,17z/data=!4m6!3m5!1s0xd665fb802f85373:0xee8ea6f8fd28dcbf!8m2!3d38.9941274!4d-1.8610788!16s%2Fg%2F11dxpdhp0j?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D',
            es_location: 'Finca El Batanejo',
            es_address: 'Villalgordo Del Jucar, Albacete',
            es_website: 'https://www.instagram.com/fincaelbatanejo/',
            es_maps_link: 'https://www.google.com/maps/place/Finca+El+Batanejo/@39.3348569,-2.0911541,17z/',
            party_photos: 'Fotos del cortejo nupcial',
            rehearsal: 'Ensayo de Boda y Cena',
            street_map_title: 'Plano de Albacete',
            zoom_map: 'Ver plano completo',
            close: 'Cerrar',
            open_google_maps: 'Abrir en Google Maps',
            bus_meeting_point_title: 'Punto de encuentro del autobús',
            bus_meeting_point_desc: 'Punta del Parque Abelardo Sánchez — Aquí es donde el autobús os recogerá y os dejará.',
            open_in_maps: 'Abrir en Google Maps'
          },
          faq_section: {
            q1: "¿QUÉ TIEMPO HARÁ EN ESTA ÉPOCA DEL AÑO?",
            a1_subtitle1: "Temperaturas medias",
            a1_text1_1: "33°C (92°F) máxima",
            a1_text1_2: "17°C (63°F) mínima",
            a1_subtitle2: "Condiciones",
            a1_text2_1: "Cielos despejados",
            a1_text2_2: "Muy soleado",
            a1_subtitle3: "Precipitación",
            a1_text3_1: "Clima seco",
            a1_text3_2: "Prácticamente 0% de lluvia",
            a1_forecast: "Pronóstico del tiempo de 10 días para albacete",
            a1_weather_btn: "EL TIEMPO EN ALBACETE",
            q2: "¿DÓNDE TENDRÁN LUGAR LA CEREMONIA Y LA RECEPCIÓN?",
            a2: "Tanto la ceremonia (19:00) como la recepción, incluyendo la hora del cóctel (20:00) y la cena (21:30), tendrán lugar en la misma finca el sábado.",
            q3: "¿QUÉ DEBO PONERME? ¿HAY CÓDIGO DE VESTIMENTA?",
            a3_p1: "A finales de agosto en Albacete suele hacer calor y hay mucho sol durante el día, con una bajada de temperatura agradable tras el atardecer.",
            a3_ladies: "",
            a3_ladies_text: "Como el lugar está en el campo, zapatos de tacón ancho, cuñas o zapatos planos elegantes son mejores que tacones de aguja.",
            a3_gentlemen: "",
            a3_gentlemen_text: "Trajes ligeros o camisas de vestir son perfectos. Las corbatas son opcionales, ¡la comodidad con el calor es clave!",
            a3_evening: "",
            a3_evening_text: "El evento será al aire libre. Las noches pueden refrescar hasta unos 17°C, así que considera traer un chal o chaqueta ligera.",
            a3_p5: "Al llegar a la finca, habrá un lugar para dejar chaquetas y zapatos por si deseas cambiarte más tarde."
          }
        }
      }
    }
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
